import { AboutMenu, Category } from "@hermes/api-model-menu";

export const isMenuDiscoveryCategory = (menuEntry?: Category) =>
    menuEntry?.subcategories !== undefined &&
    menuEntry.subcategories.length > 0;

export const isAboutMenuDiscoveryCategory = (menuEntry?: AboutMenu) =>
    menuEntry?.items !== undefined && menuEntry.items.length > 0;
